import { PersonRequest } from "@plinknz/tah-website-elements";

import { getPersonalChanges, getAddressChanges } from "./member";
import {
  BankData,
  BANK_COUNTRY,
} from "../../service/forms/config-generics/bank-details";
import {
  PersonalData,
  APPLICANT_DETAILS,
  ADDRESS,
} from "../../service/forms/config-generics/personal-details";
import { SignatureData } from "../../service/forms/config-generics/signature";
import { getGenericSVGLines } from "./generic";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { BANK_DETAILS, getBankSVGLines } from "./bank";

export interface HeadingLine {
  heading: string;
}

export interface TextLine {
  label: string;
  text: string | number;
}

export interface ImageLine {
  src: string;
}

export type SVGLine = HeadingLine | TextLine | ImageLine;

export interface SVGSourceData extends BankData, PersonalData, SignatureData {
  member: PersonRequest;
}

export interface SVGAttachment {
  name: string;
}

export interface SVGMatrixRow {
  [key: string]: string;
}

interface CreateSVGConfigProps {
  data: SVGSourceData;
  config: { pages: PageConfig[] };
}

export function createSVGConfig({ data, config }: CreateSVGConfigProps) {
  const { pages } = config;

  let allLines: SVGLine[] = [];

  for (const page of pages) {
    if (page.questions) {
      let newLines: SVGLine[] = [];

      switch (page.name) {
        case BANK_COUNTRY:
          break;
        case APPLICANT_DETAILS:
          newLines = getPersonalChanges(data);
          break;
        case ADDRESS:
          newLines = getAddressChanges(data);
          break;
        case BANK_DETAILS:
          if (data.bank) {
            newLines = getBankSVGLines(data.bank);
          }
          break;
        default:
          newLines = getGenericSVGLines({ data, page });
          break;
      }

      allLines = [...allLines, ...newLines];
    }
  }

  return allLines;
}
